import { Extension, InputRule, Node, mergeAttributes } from '@tiptap/core';
import { Blockquote } from '@tiptap/extension-blockquote';
import { Bold } from '@tiptap/extension-bold';
import { BulletList } from '@tiptap/extension-bullet-list';
import { Document } from '@tiptap/extension-document';
import { Gapcursor } from '@tiptap/extension-gapcursor';
import { HardBreak } from '@tiptap/extension-hard-break';
import { Heading } from '@tiptap/extension-heading';
import { Italic } from '@tiptap/extension-italic';
import { ListItem } from '@tiptap/extension-list-item';
import { OrderedList } from '@tiptap/extension-ordered-list';
import { Paragraph } from '@tiptap/extension-paragraph';
import { Strike } from '@tiptap/extension-strike';
import { Text } from '@tiptap/extension-text';
import TiptapLink from '@tiptap/extension-link';
import textStyleExtension from '@tiptap/extension-text-style';
export { default as textStyleExtension } from '@tiptap/extension-text-style';
import Highlight from '@tiptap/extension-highlight';
import textUnderlineExtension from '@tiptap/extension-underline';
export { default as textUnderlineExtension } from '@tiptap/extension-underline';
import TaskList from '@tiptap/extension-task-list';
import TaskItem from '@tiptap/extension-task-item';
import historyExtension from '@tiptap/extension-history';
export { default as historyExtension } from '@tiptap/extension-history';
import HorizontalRule from '@tiptap/extension-horizontal-rule';
import codeExtension from '@tiptap/extension-code';
export { default as codeExtension } from '@tiptap/extension-code';
import { Color } from '@tiptap/extension-color';
export { Color as textColorExtension } from '@tiptap/extension-color';
import codeblockExtension from '@tiptap/extension-code-block-lowlight';
export { default as codeblockExtension } from '@tiptap/extension-code-block-lowlight';
import dropCursorExtension from '@tiptap/extension-dropcursor';
export { default as dropCursorExtension } from '@tiptap/extension-dropcursor';
import { PluginKey } from '@tiptap/pm/state';
import Suggestion from '@tiptap/suggestion';

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var starterKitExtension = Extension.create({
  name: "starterKit",
  addOptions() {
    return {
      bold: {},
      blockquote: {},
      bulletList: {},
      document: {},
      gapcursor: {},
      hardBreak: {},
      heading: {},
      italic: {},
      listItem: {},
      orderedList: {},
      paragraph: {},
      strike: {},
      text: {}
    };
  },
  addExtensions() {
    const extensions = [];
    if (this.options.bold !== false) {
      extensions.push(Bold.configure(this.options.bold));
    }
    if (this.options.blockquote !== false) {
      extensions.push(Blockquote.configure(this.options.blockquote));
    }
    if (this.options.bulletList !== false) {
      extensions.push(BulletList.configure(this.options.bulletList));
    }
    if (this.options.document !== false) {
      extensions.push(Document.configure(this.options.document));
    }
    if (this.options.gapcursor !== false) {
      extensions.push(Gapcursor.configure(this.options.gapcursor));
    }
    if (this.options.hardBreak !== false) {
      extensions.push(HardBreak.configure(this.options.hardBreak));
    }
    if (this.options.heading !== false) {
      extensions.push(Heading.configure(this.options.heading));
    }
    if (this.options.italic !== false) {
      extensions.push(Italic.configure(this.options.italic));
    }
    if (this.options.listItem !== false) {
      extensions.push(ListItem.configure(this.options.listItem));
    }
    if (this.options.orderedList !== false) {
      extensions.push(OrderedList.configure(this.options.orderedList));
    }
    if (this.options.paragraph !== false) {
      extensions.push(Paragraph.configure(this.options.paragraph));
    }
    if (this.options.strike !== false) {
      extensions.push(Strike.configure(this.options.strike));
    }
    if (this.options.text !== false) {
      extensions.push(Text.configure(this.options.text));
    }
    return extensions;
  }
});
var linkExtension = TiptapLink.configure({
  openOnClick: true
});
var textHighlightExtension = Highlight.configure({
  multicolor: true
});
var taskListExtension = TaskList;
var taskItemExtension = TaskItem;
var horizontalRuleExtension = HorizontalRule.extend({
  addInputRules() {
    return [
      new InputRule({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        handler: ({ state, range }) => {
          const attributes = {};
          const { tr } = state;
          const start = range.from;
          const end = range.to;
          tr.insert(start - 1, this.type.create(attributes)).delete(
            tr.mapping.map(start),
            tr.mapping.map(end)
          );
        }
      })
    ];
  }
});

// src/extensions/extensions-configured/index.ts
var extensions_configured_exports = {};
__export(extensions_configured_exports, {
  codeExtension: () => codeExtension,
  codeblockExtension: () => codeblockExtension,
  dropCursorExtension: () => dropCursorExtension,
  historyExtension: () => historyExtension,
  horizontalRuleExtension: () => horizontalRuleExtension,
  linkExtension: () => linkExtension,
  starterKitExtension: () => starterKitExtension,
  taskItemExtension: () => taskItemExtension,
  taskListExtension: () => taskListExtension,
  textColorExtension: () => Color,
  textHighlightExtension: () => textHighlightExtension,
  textStyleExtension: () => textStyleExtension,
  textUnderlineExtension: () => textUnderlineExtension
});
var BaseEditorExtension = Extension.create({
  name: "baseEditorExtension",
  addExtensions() {
    const extensions = [];
    for (const [extensionName, extension] of Object.entries(
      extensions_configured_exports
    )) {
      if (this.options[extensionName] !== false) {
        extensions.push(extension.configure());
      }
    }
    return extensions;
  }
});
var mentionExtension = Node.create({
  name: "mention",
  addOptions() {
    return {
      HTMLAttributes: {},
      entityType: "mention",
      renderText({ options, node }) {
        return `${options.suggestion.char}${node.attrs.label ?? node.attrs.id}`;
      },
      renderHTML({ options, node }) {
        return [
          "span",
          this.HTMLAttributes,
          `${options.suggestion.char}${node.attrs.label ?? node.attrs.id}`
        ];
      },
      suggestion: {
        char: "@",
        pluginKey: new PluginKey("mention"),
        command: ({ editor, range, props }) => {
          var _a, _b;
          const { nodeAfter } = editor.view.state.selection.$to;
          const overrideSpace = (_a = nodeAfter == null ? void 0 : nodeAfter.text) == null ? void 0 : _a.startsWith(" ");
          if (overrideSpace) {
            range.to += 1;
          }
          editor.chain().focus().insertContentAt(range, [
            {
              type: this.name,
              attrs: props
            },
            {
              type: "text",
              text: " "
            }
          ]).run();
          (_b = window.getSelection()) == null ? void 0 : _b.collapseToEnd();
        },
        allow: ({ state, range }) => {
          const $from = state.doc.resolve(range.from);
          const type = state.schema.nodes[this.name];
          return !!$from.parent.type.contentMatch.matchType(type);
        }
      }
    };
  },
  group: "inline",
  inline: true,
  selectable: false,
  atom: true,
  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-id"),
        renderHTML: (attributes) => {
          if (!attributes.id) {
            return {};
          }
          return {
            "data-id": attributes.id
          };
        }
      },
      entity: {
        default: this.options.entityType,
        parseHTML: (element) => element.getAttribute("data-entity"),
        renderHTML: (attributes) => {
          if (!attributes.entity) {
            return {};
          }
          return {
            "data-entity": attributes.entity
          };
        }
      },
      label: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-label") || element.textContent,
        renderHTML: (attributes) => {
          if (!attributes.label) {
            return {};
          }
          return {
            "data-label": attributes.label
          };
        }
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: `span[data-type="${this.name}"]`
      }
    ];
  },
  renderHTML({ node, HTMLAttributes }) {
    if (this.options.renderLabel !== void 0) {
      return [
        "span",
        mergeAttributes(
          { "data-type": this.name },
          this.options.HTMLAttributes,
          HTMLAttributes
        ),
        this.options.renderLabel.call(this, {
          options: this.options,
          node,
          editor: this.editor
        })
      ];
    }
    const html = this.options.renderHTML.call(this, {
      options: this.options,
      node
    });
    if (typeof html === "string") {
      return [
        "span",
        mergeAttributes(
          { "data-type": this.name },
          this.options.HTMLAttributes,
          HTMLAttributes
        ),
        html
      ];
    }
    return html;
  },
  renderText({ node }) {
    if (this.options.renderLabel !== void 0) {
      console.warn(
        "renderLabel is deprecated use renderText and renderHTML instead"
      );
      return this.options.renderLabel.call(this, {
        options: this.options,
        node
      });
    }
    return this.options.renderText.call(this, {
      options: this.options,
      node
    });
  },
  addKeyboardShortcuts() {
    return {
      Backspace: () => this.editor.commands.command(({ tr, state }) => {
        let isMention = false;
        const { selection } = state;
        const { empty, anchor } = selection;
        if (!empty) {
          return false;
        }
        state.doc.nodesBetween(anchor - 1, anchor, (node, pos) => {
          if (node.type.name === this.name) {
            isMention = true;
            tr.insertText(
              this.options.suggestion.char || "",
              pos,
              pos + node.nodeSize
            );
            return false;
          }
          return false;
        });
        return isMention;
      })
    };
  },
  addProseMirrorPlugins() {
    return [
      Suggestion({
        editor: this.editor,
        ...this.options.suggestion
      })
    ];
  }
});
var emojiExtension = mentionExtension.extend({
  name: "emoji-search",
  addCommands() {
    return {
      addEmoji: ({ item, rangeFrom }) => ({ commands }) => commands.insertContentAt(rangeFrom, [
        { type: "emoji-search", attrs: { id: item.id } },
        { type: "text", text: " " }
      ])
    };
  },
  addAttributes() {
    return {
      id: { default: null }
    };
  },
  renderHTML({ HTMLAttributes }) {
    return [
      "em-emoji",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)
    ];
  },
  parseHTML() {
    return [
      {
        tag: "em-emoji",
        getAttrs: (element) => ({
          id: typeof element === "string" ? element : element.getAttribute("id")
        })
      }
    ];
  },
  renderText({ node }) {
    return `:${node.attrs.id}:`;
  },
  addKeyboardShortcuts() {
    return {};
  }
});

export { BaseEditorExtension, __commonJS, __toESM, emojiExtension, horizontalRuleExtension, linkExtension, mentionExtension, starterKitExtension, taskItemExtension, taskListExtension, textHighlightExtension };
